import { handleActions } from 'redux-actions';
import { LOCATION_CHANGE } from 'react-router-redux';

import cloneDeep from 'lodash/cloneDeep';

import http from '../../shared/http';
import intl from '../../shared/intl';

import checkPermissions from '../../shared/check-permissions';
import forEach from 'lodash/forEach';
import _get from 'lodash/get';
import { SubmissionError, change } from 'redux-form';

// actions types
const FETCH_DATA_SUCCESS = 'campaignPayout/fetch-data-success';
const FETCH_DATA_ERROR = 'campaignPayout/fetch-data-error';

const SUBMIT_DATA_SUCCESS = 'campaignPayout/SUBMIT_DATA_SUCCESS';
const SUBMIT_DATA_ERR = 'campaignPayout/SUBMIT_DATA_ERR';

const DELETE_DATA_SUCCESS = 'campaignPayout/DELETE_DATA_SUCCESS';

// permissions
export const allowedPermissions = {
	'campaignsEdit': 'campaigns_edit'
};

// initial state
const initialState = {
	data: null,
	showProgressBar: false,
	form: {
		campaign_id: null,
		amount: null,
		sid: null,
		currency: null
	},
	error: false
};

// actions
export const actions = Object.assign(
	{
		fetchData: () => (dispatch, getState) => {
			const campaign_id = window.location.pathname.match(/[0-9]+/g);

			const urls = [
				`v2/offer-specific-payouts?campaign_id=${campaign_id[0]}`,
				`v2/campaigns/${campaign_id[0]}`
			];

			return campaign_id && http({
				method: 'get',
				url: urls,
				actions: [ FETCH_DATA_SUCCESS, FETCH_DATA_ERROR ]
			})(dispatch)
				.then(action => {
					if (action.type === FETCH_DATA_SUCCESS) {
						const currency = _get(action, 'payload[1].data.currency');
						dispatch(change('campaignsPayoutEdit', 'currency', currency));
					}
				});
		},
		submitForm: (formData) => (dispatch, getState) => {
			return http({
				method: 'post',
				url: 'v2/offer-specific-payouts',
				actions: [ SUBMIT_DATA_SUCCESS, SUBMIT_DATA_ERR ],
				data: formData
			})(dispatch).then(action => {
				if (action.type === SUBMIT_DATA_ERR && action.payload.response.status === 400) {
					const responseErrors = action.payload.response.data;
					const validationsErrors = {};

					forEach(responseErrors, value => {
						const key = value.dataPath.slice(1);
						validationsErrors[key] = value.message;
					});

					throw new SubmissionError(validationsErrors);
				}
			});
		},
		deletePayouts: (sid, sid_type) => (dispatch, getState) => {
			const campaign_id = window.location.pathname.match(/[0-9]+/g);
			return campaign_id && http({
				method: 'delete',
				url: `v2/offer-specific-payouts?campaign_id=${campaign_id[0]}&sid=${sid}&sid_type=${sid_type || ''}`,
				actions: [ DELETE_DATA_SUCCESS ]
			})(dispatch);
		}
	}
);

// reducers
const reducers = Object.assign(
	{
		[LOCATION_CHANGE]: (state, action) => {
			return { ...initialState };
		},
		[FETCH_DATA_SUCCESS]: (state, action) => {
			return { ...state, data: action.payload[0].data, showProgressBar: false, error: false };
		},
		[DELETE_DATA_SUCCESS]: (state, action) => {
			return { ...state, data: null };
		},
		[SUBMIT_DATA_SUCCESS]: (state, action) => {
			return { ...state, data: null };
		},
		[FETCH_DATA_ERROR]: (state, action) => ({ ...state, error: false, showProgressBar: false })
	}
);
export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.campaignPayout.data,
	getCampaignCurrencySelector: state => camp_id => {
		const camp = state.campaignsList.data && state.campaignsList.data.find(i => i.id === Number(camp_id));

		return camp && camp.currency;
	},
	getIntl: state => intl(state),
	getProgressBar: state => state.campaignPayout.showProgressBar,
	getActivePayoutCurrencies: state => state.root.lists['payout-currencies'].map(i => i.id),
	getCan: state => checkPermissions(state, allowedPermissions),
	getError: state => state.campaignPayout.error
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/campaigns/payout-editor/index.js